export const isDefined = (value) => !!(value ?? false) || value === 0;
export const isDefinedNotZero = (value) => isDefined(value) && value !==0;
